/**
 * Image variation generation.
 *
 * `useImageVariations` runs the whole pipeline for a set of template stages —
 * describing the reference images, generating the prompts, uploading the
 * references and generating the variations themselves — and is what a wizard
 * step's `enter.run()` arms.
 *
 * `useImageVariation` (singular) is the counterpart for a view that works on
 * one variation: it resolves that variation and edits the data the pipeline
 * reacts to, without running a pipeline of its own.
 *
 * Each middle step is also exported on its own, so a step that only needs one
 * of them (describing an uploaded image, generating a prompt, uploading a
 * reference) can use it without the rest.
 *
 * What each variation `type` means — its prompt and the request that generates
 * it — is configured in one place: `VARIATION_TYPES` in `variationTypes.js`.
 */

export { useImageVariations } from "./useImageVariations";
export { useImageVariation } from "./useImageVariation";
export { useImageLabeling } from "./useImageLabeling";
export { useImagePrompts } from "./useImagePrompts";
export { useImageReferenceUploads } from "./useImageReferenceUploads";
export { usePersistImageVariations } from "./usePersistImageVariations";
export {
  REFERENCE_KIND,
  getMissingReferenceKind,
  getReferenceTitle,
  getReferenceTitleParts,
  resolveAsset,
  resolveFallbackAsset,
  resolveReferenceAssets,
  resolveVariation,
  resolveVariationAsset,
} from "./resolve";
export { VARIATION_TYPES, getVariationType } from "./variationTypes";
export {
  buildVariationPayload,
  compileUserPrompt,
  getVariationPromptTemplate,
  isStaticPrompt,
  resolveStaticPrompt,
} from "./variationRequest";
export { SKIP_IMAGE_LABELING_TEMPLATES } from "./variationPrompts";
